import { enableTempStorage } from '@opsbase/lib-storage';
import useParams from '@opsbase/web-nav/useParams';
import React from 'react';
import { getDetailsReportDefinition } from './DetailsReportDefinition';
import DetailsIssueReportPage from './issue/DetailsIssueReportPage';
import DetailsOpReportPage from './op/DetailsOpReportPage';
export default function DetailsReportPage() {
    enableTempStorage();
    const { key } = useParams();
    const { type } = getDetailsReportDefinition(key);
    return type === 'op' ? React.createElement(DetailsOpReportPage, null) : React.createElement(DetailsIssueReportPage, null);
}
